module.exports = __webpack_public_path__ + "static/img/lactulose.17a5e51a.jpg";